import { get } from 'lodash';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import fetchData from '@utils/fetchData';

import { downloadTransactionsExcel, getFileName } from './helpers';
import { GET_MD_COUNTRIES_QUERY, GET_PAY_TRANSACTION_QUERY } from './queries';
import {
  getCountriesAction,
  getCountriesErrorAction,
  getCountriesSuccessAction,
  getTransactionsAction,
  getTransactionsErrorAction,
  getTransactionsSuccessAction,
} from './slice';
import { Country, Transactions } from './types';

interface GetTransactionListAction {
  type: string;
  payload: {
    conditions: object;
    limit: number;
    offset: number;
    isDownloadList?: boolean;
  };
}

interface TransactionPayload {
  data: Transactions[];
  count: number;
  isDownloadList?: boolean;
}

interface TransactionErrorPayload {
  error: string | Error;
  isDownloadList?: boolean;
}

export function* getTransactionsListSaga(action: GetTransactionListAction) {
  const { limit, offset, conditions, isDownloadList } = action.payload;
  const queryVariables = {
    ...(limit && { limit: limit }),
    ...(offset && { offset: offset }),
    conditions: conditions,
  };
  try {
    const response: Transactions[] = yield call(fetchData, {
      queryString: GET_PAY_TRANSACTION_QUERY,
      queryKey: 'pay_transaction',
      queryVariables: queryVariables,
      forceRefresh: true,
    });

    const aggregateResponse: {
      aggregate: { count: number };
    } = yield call(fetchData, {
      queryString: GET_PAY_TRANSACTION_QUERY,
      queryKey: 'pay_transaction_aggregate',
      queryVariables: queryVariables,
      forceRefresh: true,
    });
    const count = get(aggregateResponse, 'aggregate.count', 0);
    if (response) {
      const payload: TransactionPayload = { data: response, count: count };

      if (isDownloadList) {
        payload.isDownloadList = isDownloadList;
        const filename = getFileName('transactions_list');
        downloadTransactionsExcel(response, filename);
      }

      yield put(getTransactionsSuccessAction(payload));
    }
  } catch (error) {
    const payload: TransactionErrorPayload = {
      error: error as string | Error,
    };

    if (isDownloadList) {
      payload.isDownloadList = isDownloadList;
    }

    yield put(getTransactionsErrorAction(payload));
  }
}

export function* getCountriesListSaga() {
  const queryVariables = {};
  try {
    const response: Country[] = yield call(fetchData, {
      queryString: GET_MD_COUNTRIES_QUERY,
      queryKey: 'md_country',
      queryVariables: queryVariables,
      forceRefresh: true,
    });
    if (response) {
      yield put(getCountriesSuccessAction({ data: response }));
    }
  } catch (error) {
    yield put(getCountriesErrorAction(error as string | Error));
  }
}

export function* TransactionListSaga() {
  yield takeLatest(getTransactionsAction.type, getTransactionsListSaga);
}

export function* CountriesListSaga() {
  yield takeLatest(getCountriesAction.type, getCountriesListSaga);
}

export function* TransactionsSaga() {
  yield all([TransactionListSaga(), CountriesListSaga()]);
}
